import { FC, Fragment, useCallback } from "react";
import { MenuItem, Tooltip } from "@mui/material";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import DashboardCustomizeOutlinedIcon from "@mui/icons-material/DashboardCustomizeOutlined";
import { DashboardMoveActionDialogContent } from "./DashboardMoveActionDialogContent";
import { HierarchyItemMoveActionItemProps } from "../../../../../../utils/types/hierarchy";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { ConfirmationDialog } from "@/components/common/modals/ConfirmationDialog";
import { useDialog } from "@/utils/hooks/useDialog.hook";
import { useAppSelector } from "@/store/hooks";
import { updateDashboardVisibilityHierarchyLoadingSelector } from "@/store/dashboards/selectors/dashboard-hierarchy-visibility/updateDashboardVisibilityHierarchyLoadingSelector";

interface DashboardV2ItemMoveActionMenuFolderItemProps
  extends HierarchyItemMoveActionItemProps {}

export const DashboardV2ItemMoveActionMenuFolderItem: FC<
  DashboardV2ItemMoveActionMenuFolderItemProps
> = ({
  id,
  name,
  root,
  onClick,
  paddingLeft,
  visibility,
  currentItemName,
  differentVisibilities,
  disabled,
  tooltipTitle,
}) => {
  const loading = useAppSelector(
    updateDashboardVisibilityHierarchyLoadingSelector,
  );
  const { open, openDialog, closeDialog } = useDialog();

  const moveHandler = useCallback(() => {
    onClick(id);
  }, [id, onClick]);

  const clickHandler = useCallback(() => {
    if (differentVisibilities) {
      openDialog();
    } else {
      moveHandler();
    }
  }, [differentVisibilities, moveHandler, openDialog]);

  return (
    <Fragment>
      <Tooltip title={tooltipTitle} arrow>
        <span>
          <MenuItem
            onClick={clickHandler}
            sx={{ pl: paddingLeft }}
            disabled={disabled}
          >
            {root ? (
              <DashboardCustomizeOutlinedIcon fontSize="small" />
            ) : (
              <FolderOpenOutlinedIcon fontSize="small" />
            )}
            <TypographyWithTooltip
              title={name}
              variant="body2"
              placement="top"
              sx={{ pl: 1 }}
            />
          </MenuItem>
        </span>
      </Tooltip>

      {open && (
        <ConfirmationDialog
          open
          title="Move Dashboard?"
          dialogContent={
            <DashboardMoveActionDialogContent
              currentItemName={currentItemName}
              visibility={visibility}
            />
          }
          CancelButtonProps={{
            onClick: closeDialog,
          }}
          ConfirmButtonProps={{
            children: "Move",
            onClick: moveHandler,
            loading,
          }}
          onClose={closeDialog}
        />
      )}
    </Fragment>
  );
};
